export { default } from './Enllac';
